export const SEC_IN_MS = 1000;
export const MIN_IN_MS = 60 * SEC_IN_MS;
